import React, { useState, useEffect } from 'react';
import styles from './dwn-style.module.css';
import { useNavigate } from 'react-router-dom';

const FitRecruitment = () => {


const navigate = useNavigate();


    



  const [youthHeight, setYouthHeight] = useState(0);
  const [youthWeight, setYouthWeight] = useState(0);
  const [youthGender, setYouthGender] = useState('');
  const [youthAgeInMonths, setYouthAgeInMonths] = useState(0);

  const [caregiverHeight, setCaregiverHeight] = useState(0);
  const [caregiverWeight, setCaregiverWeight] = useState(0);

  const [hasSmartphones, setHasSmartphones] = useState("");
  const [proficientInEnglish, setProficientInEnglish] = useState("");
  const [medicationsCausingWeightGain, setMedicationsCausingWeightGain] = useState("");
  const [chronicCondition, setChronicCondition] = useState("");
  const [plansOrCurrentlyPregnant, setPlansOrCurrentlyPregnant] = useState("");
  const [mentalDisorderOrSuicidalThoughts, setMentalDisorderOrSuicidalThoughts] = useState("");
  const [cognitiveImpairments, setCognitiveImpairments] = useState("");
  const [unsafeToLoseWeight, setUnsafeToLoseWeight] = useState("");
  const [otherObesityTreatments, setOtherObesityTreatments] = useState("");
  const [isYouthAfricanAmerican, setIsYouthAfricanAmerican] = useState(null);

  const [ZIP, setZIP] = useState(0);



// Function to notify and post contact information
const notify = async (eligibleInfo) => {
    const url = "https://app.digitalwellnessnurse.com/api/portal/fit/eligibility-notification";    //https://app.digitalwellnessnurse.com  http://localhost:2001
  
    try {
      const response = await fetch(url, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(eligibleInfo),
      });
  
      if (response.status != 200) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
  
      if (window.confirm("You are potentially eligible for the study! You will be contacted via text messaging.")) {
        exit();
      }    
     } catch (error) {
      console.error("Error notifying eligibility:", error);
      alert("An error occurred while submitting your contact information. Please try again later.");
    }
  };

  const exit = () =>{

    
    navigate('/FitThankYou',)

  }

  const validateForm = () => {
    const missingFields = [];
  
    // Helper function to check null, empty string, or non-positive values
    const isInvalidValue = (value) => value === null || value === '' || value <= 0;
  
    // Validate youth-related fields
    if (isInvalidValue(youthHeight)) missingFields.push("Youth Height (must be a positive value)");
    if (isInvalidValue(youthWeight)) missingFields.push("Youth Weight (must be a positive value)");
    if (!youthGender) missingFields.push("Youth Gender");
    if (isInvalidValue(youthAgeInMonths)) missingFields.push("Youth Age in Months (must be a positive value)");
  
    // Validate caregiver-related fields
    if (isInvalidValue(caregiverHeight)) missingFields.push("Caregiver Height (must be a positive value)");
    if (isInvalidValue(caregiverWeight)) missingFields.push("Caregiver Weight (must be a positive value)");
  
    // Validate yes/no fields
    if (!hasSmartphones) missingFields.push("Smartphones Availability");
    if (!proficientInEnglish) missingFields.push("English Proficiency");
    if (!medicationsCausingWeightGain) missingFields.push("Medications Causing Weight Gain");
    if (!chronicCondition) missingFields.push("Chronic Condition");
    if (!plansOrCurrentlyPregnant) missingFields.push("Pregnancy Status");
    if (!mentalDisorderOrSuicidalThoughts) missingFields.push("Mental Disorder or Suicidal Thoughts");
    if (!cognitiveImpairments) missingFields.push("Cognitive Impairments");
    if (!unsafeToLoseWeight) missingFields.push("Safety to Lose Weight");
    if (!otherObesityTreatments) missingFields.push("Other Obesity Treatments");
    if (isYouthAfricanAmerican === null) missingFields.push("Youth African American Status");
  
    if( Math.abs(ZIP).toString().length != 5) missingFields.push("ZIP (must be five digits)");

  
    // Handle missing fields
    if (missingFields.length > 0) {
      alert(`The following fields are missing or invalid:\n- ${missingFields.join("\n- ")}`);
      return false; // Form is not valid
    }
  
    return true; // Form is valid
  };
  
  

  
  
  // Function to verify eligibility
  const verifyEligibility = async () => {




    if(validateForm())
    {
        let input = {
        youthHeight,
        youthWeight,
        youthGender,
        youthAgeInMonths,
        caregiverHeight,
        caregiverWeight,
        hasSmartphones,
        proficientInEnglish,
        medicationsCausingWeightGain,
        chronicCondition,
        plansOrCurrentlyPregnant,
        mentalDisorderOrSuicidalThoughts,
        cognitiveImpairments,
        unsafeToLoseWeight,
        otherObesityTreatments,
        isYouthAfricanAmerican,
        ZIP,
        };
    
        const url = "https://app.digitalwellnessnurse.com/api/portal/fit/verify-eligibility";   //https://app.digitalwellnessnurse.com  http://localhost:2001
    
        try {
        const response = await fetch(url, {
            method: "POST",
            headers: {
            "Content-Type": "application/json",
            },
            body: JSON.stringify(input),
        });
    
        if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
        }
    
        const result = await response.json();
    
        // If eligible, display a modal
        if (result.eligible) {
            showEligibilityModal(result);
        } else {
            alert("Unfortunately, you are not eligible for this study.");
        }
        } catch (error) {
        console.error("Error verifying eligibility:", error);
        alert("An error occurred while verifying eligibility. Please try again later.");
        }
    }
  };
  
  // Function to show the modal
  const showEligibilityModal = (result) => {
    const modalHtml = `
      <div id="eligibility-modal" style="
        position: fixed;
        top: 0; left: 0; width: 100%; height: 100%;
        background-color: rgba(0, 0, 0, 0.5);
        display: flex; justify-content: center; align-items: center;
        z-index: 1000;
      ">
        <div style="
          background: white; padding: 20px; border-radius: 8px; width: 400px; text-align: center;
        ">
          <h2>Congratulations!</h2>
          <p>You are potentially eligible for the study. Please provide your contact information below:</p>
          <form id="contact-form" style="margin-top: 15px;">
            <input type="text" id="first-name" placeholder="First Name" required style="width: 100%; margin-bottom: 10px; padding: 8px;" />
            <input type="text" id="last-name" placeholder="Last Name" required style="width: 100%; margin-bottom: 10px; padding: 8px;" />
            <input type="tel" id="phone-number" placeholder="Phone Number" required style="width: 100%; margin-bottom: 10px; padding: 8px;" />
            <button type="submit" style="
              background-color: #4CAF50; color: white; border: none; padding: 10px 20px; cursor: pointer;
              border-radius: 4px; font-size: 16px;
            ">Submit</button>
          </form>
          <button id="close-modal" style="
            background-color: red; color: white; border: none; padding: 8px 16px; cursor: pointer;
            border-radius: 4px; margin-top: 10px;
          ">Close</button>
        </div>
      </div>
    `;
  
    // Append the modal to the body
    const modalContainer = document.createElement("div");
    modalContainer.innerHTML = modalHtml;
    document.body.appendChild(modalContainer);
  
    // Add event listener for the close button
    document.getElementById("close-modal").addEventListener("click", () => {
      modalContainer.remove();
    });
  
    // Add event listener for the form submission
    document.getElementById("contact-form").addEventListener("submit", async (e) => {
      e.preventDefault();
  
      const firstName = document.getElementById("first-name").value;
      const lastName = document.getElementById("last-name").value;
      const phoneNumber = document.getElementById("phone-number").value;
      const  date = new Date();
      const contacted = false;
      
      if (firstName && lastName && phoneNumber) {
        const eligibleInfo = {
          firstName,
          lastName,
          phoneNumber,
          date,
          contacted,
          result,
        };
  
        await notify(eligibleInfo); // Call the notify function
        modalContainer.remove();
      } else {
        alert("Please fill in all the required fields.");
      }
    });
  };
  
  
  
    const convertToMeters = (feet, inches, fraction) => {
      const totalInches = parseFloat(feet || 0) * 12 + parseFloat(inches || 0) + parseFloat(fraction || 0);
      return (totalInches / 39.37).toFixed(2);
    };
  
    const convertToKgs = (lbs) => {
      return (parseFloat(lbs || 0) * 0.453592).toFixed(2);
    };



      

    const handleZIPChange = (e) => {
        const ZIP_Code = document.getElementById('ZIP').value.trim();
        setZIP(ZIP_Code);
      };


  
    const handleYouthHeightChange = (e) => {
      const feet = document.getElementById('youthFeet').value;
      const inches = document.getElementById('youthInches').value;
      const fraction = 0;
      setYouthHeight(convertToMeters(feet, inches, fraction));
    };
  
    const handleCaregiverHeightChange = (e) => {
      const feet = document.getElementById('caregiverFeet').value;
      const inches = document.getElementById('caregiverInches').value;
      const fraction = 0;
      setCaregiverHeight(convertToMeters(feet, inches, fraction));
    };


    const handleDOBChange = (e) => {
        const dob = e.target.value;
        console.log(dob)
        const ageInMonths = calculateAgeInMonths(dob);
        setYouthAgeInMonths(ageInMonths); // Save the calculated age in months
      };

      const calculateAgeInMonths = (dob) => {
        const birthDate = new Date(dob);
        const currentDate = new Date();
      
        let yearsDifference = currentDate.getFullYear() - birthDate.getFullYear();
        let monthsDifference = currentDate.getMonth() - birthDate.getMonth();
        let daysDifference = currentDate.getDate() - birthDate.getDate();
      
        // Adjust months if the current day is before the birthday in the current month
        if (daysDifference < 0) {
          monthsDifference--;
        }
      
        // Adjust years if the current date is before the birthday in the current year
        if (monthsDifference < 0) {
          yearsDifference--;
          monthsDifference += 12;
        }
      
        const ageInMonths = yearsDifference * 12 + monthsDifference;
      
        console.log(ageInMonths);
      
        return ageInMonths >= 0 ? ageInMonths : 0; // Ensure no negative age
      };
      
  
    


  return (
    <div className={styles.fitRecruitmentContainer}>
      {/* About the Study Section */}
      <section className={styles.aboutSection}>
        <h2 className={styles.sectionTitle}>Study Description</h2>
        <p className={styles.latinText}>
          This study checks the effectiveness of a family-based treatment for adolescent obesity.
          The study uses a mobile app and real, human personal health coaches to guide participants through the program.
        </p>
        <ul className={styles.latinText}>
          <li>12-week study</li>
          <li>Encourages health & wellness education, exercise, fitness tracking, & healthy nutrition</li>
          <li>Free access to evidence-based health & wellness content</li>
          <li>Free access to a real, human personal health coach</li>
        </ul>

        <h3 className={styles.sectionSubtitle}>Potential Benefits</h3>
        <p className={styles.latinText}>
          The study may improve your and your caregiver’s physical well-being, but that cannot be guaranteed.
        </p>

        <h3 className={styles.sectionSubtitle} style={{ color: 'darkgreen' }}>
          COMPENSATION AVAILABLE
        </h3>
        <p className={styles.latinText}>
          Each participant (adolescent <strong>AND</strong> caregiver) can earn up to <strong>$1400</strong>.
        </p>
      </section>

       {/* Youth BMI Section */}
      <section cclassName={styles.bmiSection}>
        <h2 cclassName={styles.sectionTitle}>Enter Information To Calculate Body Mass Index (BMI)</h2>

        <div>

          {/* Height Subsection */}
          <div cclassName={styles.bmiEntry}>
            <h4 cclassName={styles.sectionTitle}>Youth Height</h4>
            <label cclassName={styles.bmiLabel}>Feet (ft):</label>
            <input id="youthFeet" type="numeric" className="bmiInput" onChange={handleYouthHeightChange} />

            <label cclassName={styles.bmiLabel}>Inches (in):</label>
            <input id="youthInches" type="numeric" className="bmiInput" onChange={handleYouthHeightChange} />
          </div>

          {/* Weight Subsection */}
          <div cclassName={styles.bmiEntry}>
            <label cclassName={styles.bmiLabel}>Youth Weight (lbs):</label>
            <input
              type="numeric"
              className="bmiInput"
              onChange={(e) => setYouthWeight(convertToKgs(e.target.value))}
            />
          </div>

          {/* Age Subsection */}
          <div cclassName={styles.bmiEntry}>
            <label cclassName={styles.bmiLabel}>Youth Date of Birth:</label>
            <input type="date" className="bmiInput" onChange={handleDOBChange} />
          </div>

          {/* Gender Subsection */}
          <div cclassName={styles.bmiEntry}>
            <h4 cclassName={styles.sectionTitle}>Youth Gender</h4>
            <label cclassName={styles.bmiLabel}>
              <input
                type="radio"
                value="boy"
                name="youthGender"
                onChange={(e) => setYouthGender(e.target.value)}
              />
              Boy
            </label>
            <label cclassName={styles.bmiLabel}>
              <input
                type="radio"
                value="girl"
                name="youthGender"
                onChange={(e) => setYouthGender(e.target.value)}
              />
              Girl
            </label>
          </div>
        </div>
      </section>

      {/* Caregiver BMI Section */}
      <section cclassName={styles.bmiSection}>

        {/* Height Subsection */}
        <div cclassName={styles.bmiEntry}>
          <h4 cclassName={styles.sectionTitle}>Caregiver Height</h4>
          <label cclassName={styles.bmiLabel}>Feet (ft):</label>
          <input id="caregiverFeet" type="numeric" className="bmiInput" onChange={handleCaregiverHeightChange} />

          <label cclassName={styles.bmiLabel}>Inches (in):</label>
          <input id="caregiverInches" type="numeric" className="bmiInput" onChange={handleCaregiverHeightChange} />
        </div>

        {/* Weight Subsection */}
        <div cclassName={styles.bmiEntry}>
          <label cclassName={styles.bmiLabel}>Caregiver Weight (lbs):</label>
          <input
            type="numeric"
            className="bmiInput"
            onChange={(e) => setCaregiverWeight(convertToKgs(e.target.value))}
          />
        </div>
      </section>


      <div>
      <h3 className={styles.sectionTitle}>Criteria</h3>

      <div className={styles.criteriaSection}>

      <div className={styles.criteriaItem}>
          <label className={styles.criteriaQuestion}>
            Enter your ZIP Code
          </label>
          <input id="ZIP" type="numeric" className="bmiInput" onChange={handleZIPChange} />
        </div>


      <div className={styles.criteriaItem}>
          <label className={styles.criteriaQuestion}>
            Does the youth identify as an African American?
          </label>
          <div>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                value="yes"
                checked={isYouthAfricanAmerican === "yes"}
                onChange={() => setIsYouthAfricanAmerican("yes")}
              />
              Yes
            </label>
            <label className={styles.criteriaOption}>
              <input
                type="radio"
                value="no"
                checked={isYouthAfricanAmerican === "no"}
                onChange={() => setIsYouthAfricanAmerican("no")}
              />
              No
            </label>
          </div>
       </div>


        <div className={styles.criteriaItem}>
           <label className={styles.criteriaQuestion}>
            Do you and the adolescent have separate Android or Apple smartphones with a mobile internet connection?
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="smartphones"
              value="yes"
              onChange={() => setHasSmartphones("yes")}
            />
            Yes
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="smartphones"
              value="no"
              onChange={() => setHasSmartphones("no")}
            />
            No
          </label>
        </div>

        <div className={styles.criteriaItem}>
        <label className={styles.criteriaQuestion}>Are you and the adolescent proficient in English?</label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="english"
              value="yes"
              onChange={() => setProficientInEnglish("yes")}
            />
            Yes
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="english"
              value="no"
              onChange={() => setProficientInEnglish("no")}
            />
            No
          </label>
        </div>

        <div className={styles.criteriaItem}>
        <label className={styles.criteriaQuestion}>
            Has the child been prescribed any medications, like steroids or antipsychotics, that might have caused weight gain?
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="medications"
              value="yes"
              onChange={() => setMedicationsCausingWeightGain("yes")}
            />
            Yes
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="medications"
              value="no"
              onChange={() => setMedicationsCausingWeightGain("no")}
            />
            No
          </label>
        </div>

        <div className={styles.criteriaItem}>
        <label className={styles.criteriaQuestion}>
            Does the child have a chronic condition, such as Down syndrome, Prader-Willi syndrome, or Cushing's syndrome, that could contribute to obesity?
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="chronicCondition"
              value="yes"
              onChange={() => setChronicCondition("yes")}
            />
            Yes
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="chronicCondition"
              value="no"
              onChange={() => setChronicCondition("no")}
            />
            No
          </label>
        </div>

        <div className={styles.criteriaItem}>
        <label className={styles.criteriaQuestion}>
            Are you or the youth currently pregnant or planning to become pregnant?
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="pregnancy"
              value="yes"
              onChange={() => setPlansOrCurrentlyPregnant("yes")}
            />
            Yes
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="pregnancy"
              value="no"
              onChange={() => setPlansOrCurrentlyPregnant("no")}
            />
            No
          </label>
        </div>

        <div className={styles.criteriaItem}>
        <label className={styles.criteriaQuestion}>
            Do you or the youth have a mental or emotional disorder, such as schizophrenia or another psychotic disorder, or have either of you experienced thoughts of suicide or harming others?
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="mentalDisorder"
              value="yes"
              onChange={() => setMentalDisorderOrSuicidalThoughts("yes")}
            />
            Yes
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="mentalDisorder"
              value="no"
              onChange={() => setMentalDisorderOrSuicidalThoughts("no")}
            />
            No
          </label>
        </div>

        <div className={styles.criteriaItem}>
        <label className={styles.criteriaQuestion}>
            Do you or the youth have serious cognitive impairments that make it difficult to complete questionnaires or follow instructions?
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="cognitiveImpairments"
              value="yes"
              onChange={() => setCognitiveImpairments("yes")}
            />
            Yes
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="cognitiveImpairments"
              value="no"
              onChange={() => setCognitiveImpairments("no")}
            />
            No
          </label>
        </div>

        <div className={styles.criteriaItem}>
        <label className={styles.criteriaQuestion}>
            Do you or the youth have a medical condition where losing weight would not be safe or recommended?
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="unsafeWeightLoss"
              value="yes"
              onChange={() => setUnsafeToLoseWeight("yes")}
            />
            Yes
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="unsafeWeightLoss"
              value="no"
              onChange={() => setUnsafeToLoseWeight("no")}
            />
            No
          </label>
        </div>

        <div className={styles.criteriaItem}>
        <label className={styles.criteriaQuestion}>
            Do you or the youth plan to receive or are either of you currently receiving other obesity treatments, such as medication or bariatric surgery, within the next 6 months?
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="obesityTreatments"
              value="yes"
              onChange={() => setOtherObesityTreatments("yes")}
            />
            Yes
          </label>
          <label className={styles.criteriaOption}>
            <input
              type="radio"
              name="obesityTreatments"
              value="no"
              onChange={() => setOtherObesityTreatments("no")}
            />
            No
          </label>
        </div>
      </div>
    </div>

    <button className={styles.submitBtn} type="button" onClick={verifyEligibility}>Submit</button>

    </div>
  );
};


export default FitRecruitment;
